function createOverlay(image) {
  const overlayImage = document.createElement('img');
  overlayImage.setAttribute('src', `${image.src}`);
  overlay = document.createElement('div');
  prepareOverlay(overlay, overlayImage);
  
  image.parentElement.insertBefore(overlay, image);
  
  return overlay;
}

function prepareOverlay(container, image) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = `url('${image.src}')`;
  container.style.backgroundColor = 'var(--gradient-background)';
}

function moveWithHover(image, event, zoomRatio) {
  const ratio = image.height / image.width;
  const container = event.target.getBoundingClientRect();
  const xPosition = event.clientX - container.left;
  const yPosition = event.clientY - container.top;
  const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
  const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;

  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
}

function magnify(image, zoomRatio) {
  const overlay = createOverlay(image);
  overlay.onclick = () => overlay.remove();
  overlay.onmousemove = (event) => moveWithHover(image, event, zoomRatio);
  overlay.onmouseleave = () => overlay.remove();
}

function enableZoomOnHover(zoomRatio) {
  if (window.innerWidth < 750) {
    return;
  }
  const images = document.querySelectorAll('.image-magnify-hover');
  images.forEach((image) => {
    image.onmouseover = (event) => {
      magnify(image, zoomRatio);
      moveWithHover(image, event, zoomRatio);
    };
  });
}

// Enable pinch zoom for mobile devices (width < 750px)
function enablePinchZoom() {
  if (window.innerWidth >= 750) {
    return;
  }
  
  const productImages = document.querySelectorAll('.product__media img');
  
  productImages.forEach((img) => {
    // Store initial touch points
    let initialScale = 1;
    let currentScale = 1;
    let initialDistance = 0;
    let lastTouchX = 0;
    let lastTouchY = 0;
    
    // Add touch event listeners
    img.addEventListener('touchstart', function(e) {
      if (e.touches.length === 2) {
        e.preventDefault();
        initialDistance = getDistanceBetweenTouches(e);
        initialScale = currentScale || 1;
        
        // Calculate the center point between the two touches
        const touch1 = e.touches[0];
        const touch2 = e.touches[1];
        
        // Get coordinates relative to the image
        const rect = img.getBoundingClientRect();
        const touchX = ((touch1.clientX + touch2.clientX) / 2) - rect.left;
        const touchY = ((touch1.clientY + touch2.clientY) / 2) - rect.top;
        
        // Convert to percentages
        lastTouchX = (touchX / rect.width) * 100;
        lastTouchY = (touchY / rect.height) * 100;
        
        // Set transform origin to the touch point
        img.style.transformOrigin = `${lastTouchX}% ${lastTouchY}%`;
      }
    }, { passive: false });
    
    img.addEventListener('touchmove', function(e) {
      if (e.touches.length === 2) {
        e.preventDefault();
        const currentDistance = getDistanceBetweenTouches(e);
        const scaleFactor = currentDistance / initialDistance;
        
        // Calculate new scale - limit between 1 and 3
        currentScale = Math.min(Math.max(initialScale * scaleFactor, 1), 3);
        
        // Calculate the center point between the two touches
        const touch1 = e.touches[0];
        const touch2 = e.touches[1];
        
        // Get coordinates relative to the image
        const rect = img.getBoundingClientRect();
        const touchX = ((touch1.clientX + touch2.clientX) / 2) - rect.left;
        const touchY = ((touch1.clientY + touch2.clientY) / 2) - rect.top;
        
        // Convert to percentages
        lastTouchX = (touchX / rect.width) * 100;
        lastTouchY = (touchY / rect.height) * 100;
        
        // Update transform origin
        img.style.transformOrigin = `${lastTouchX}% ${lastTouchY}%`;
        
        // Apply transform
        img.style.transform = `scale(${currentScale})`;
      }
    }, { passive: false });
    
    img.addEventListener('touchend', function() {
      if (currentScale === 1) {
        img.style.transform = '';
        img.style.transformOrigin = 'center';
      }
    });
  });
}

// Calculate distance between two touch points
function getDistanceBetweenTouches(event) {
  const touch1 = event.touches[0];
  const touch2 = event.touches[1];
  
  const dx = touch1.clientX - touch2.clientX;
  const dy = touch1.clientY - touch2.clientY;
  
  return Math.sqrt(dx * dx + dy * dy);
}

// Run both zoom functions
enableZoomOnHover(2);
enablePinchZoom();

// Re-initialize pinch zoom on window resize
window.addEventListener('resize', function() {
  enablePinchZoom();
});
